import { CmStreamingFormat } from '../cta/CmStreamingFormat.js';

/**
 * Common Media Server Data Streaming Format
 *
 * @group CMSD
 *
 * @enum
 *
 * @beta
 */
export const CmsdStreamingFormat = CmStreamingFormat as typeof CmStreamingFormat;

/**
 * @beta
 */
export type CmsdStreamingFormat = CmStreamingFormat;
